import axios from 'axios';
import { settings } from '@/plugins/settings';
import { IShortUser } from '@/model/shortInterfaces';

export interface ICommunityUser extends IShortUser {
  delivery_token: string | null;
}

export interface ICommunityUserPage {
  data: ICommunityUser[];
  current_page: number;
  last_page: number;
  per_page: number;
  total: number;
}

const base = (communityId: number) => settings.endpoint + 'communities/' + communityId + '/users';

export const communityUserService = {
  fetchByCommunity(communityId: number, params?: { page?: number; per_page?: number }): Promise<ICommunityUserPage> {
    return axios({ url: base(communityId), method: 'GET', params }).then((response: any) => {
      const page = response && response.data && response.data.data;
      if (page && Array.isArray(page.data)) return page;
      return { data: [], current_page: 1, last_page: 1, per_page: (params && params.per_page) || 15, total: 0 };
    });
  },
  async fetchAllByCommunity(communityId: number): Promise<ICommunityUser[]> {
    const users: ICommunityUser[] = [];
    let currentPage = 1;
    let lastPage = 1;
    do {
      const page = await communityUserService.fetchByCommunity(communityId, { page: currentPage, per_page: 100 });
      users.push(...page.data);
      lastPage = page.last_page;
      currentPage++;
    } while (currentPage <= lastPage);
    return users;
  },
};
